export const MAIN_CLASS_NAME = 'connectors-modal';
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const SEARCH_CLASS_NAME = `${CONTENT_CLASS_NAME}__search`;
export const PLACEHOLDER_CLASS_NAME = `${CONTENT_CLASS_NAME}__placeholder`;
export const BUTTONS_CLASS_NAME = `${MAIN_CLASS_NAME}__buttons`;

export const CONNECTOR_PAGE_SIZE = 10;
